import { render, staticRenderFns } from "./SbppsInstructorBulkIcardPrint.vue?vue&type=template&id=61d5e8fa&scoped=true&"
import script from "./SbppsInstructorBulkIcardPrint.vue?vue&type=script&lang=js&"
export * from "./SbppsInstructorBulkIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./SbppsInstructorBulkIcardPrint.vue?vue&type=style&index=0&id=61d5e8fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d5e8fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VOverlay,VProgressCircular,VRow,VSpacer})
